module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/ucc/ucc.component.css
// module id = ./src/app/dashboard/ucc/ucc.component.css
// module chunks = main